import { useWhitelabelConfig } from '../../services/useWhitelabelConfig';

import Footer, { TFooter } from './Footer';

export default function FooterForTenant(
  props: { isLoggedIn?: boolean; isAccountView?: boolean } & Omit<
    TFooter,
    | 'hasNavItems'
    | 'hasSocialLinks'
    | 'sureFooterLogoSrc'
    | 'hasPersonalInfoLink'
    | 'tenantPhoneVariant'
    | 'footerSlug'
    | 'copyrightSlug'
    | 'cmsContentTestId'
  >
) {
  const {
    wlConfig: {
      cmsSlugs: { authenticatedFooterSlug, footerSlug, copyrightSlug },
      footerConfig,
    },
  } = useWhitelabelConfig();

  const { isLoggedIn, isAccountView, ...otherProps } = props;
  const hasPersonalInfoLink = !isLoggedIn || !isAccountView;
  const footerCmsSlug = isAccountView ? authenticatedFooterSlug : footerSlug;
  const cmsContentTestId = isAccountView
    ? 'footer-disclaimer-account'
    : 'footer-disclaimer';

  return (
    <Footer
      {...otherProps}
      {...footerConfig}
      hasPersonalInfoLink={hasPersonalInfoLink}
      footerSlug={footerCmsSlug}
      copyrightSlug={copyrightSlug}
      cmsContentTestId={cmsContentTestId}
    />
  );
}
export * from './Footer';
